
import request from '../utils/request'

const prefix = '/api/v1/back'
/**
 * 录取登记院校专业（查询列表）
 * @param {*} query
 */
export const collegeMajorList = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeMajor/list`,
        method: 'get',
        params: query
    })
}
/**
 * 录取登记院校专业（批量删除）
 * @param {*} query
 */
export const collegeMajorDelete = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeMajor/list`,
        method: 'delete',
        data: query
    })
}

/**
 * 录取登记院校专业（导出）
 * @param {*} query
 */
export const collegeMajorExport = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeMajor/list/export`,
        method: 'get',
        params: query
    })
}
/**
 * 院校简介查询详情（导出）
 * @param {*} query
 */
export const collegeIntroductDetail = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeIntroduct`,
        method: 'get',
        params: query
    })
}

/**
 * 院校简介（创建）
 * @param {*} query
 */
export const collegeIntroductCreated = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeIntroduct`,
        method: 'post',
        data: query
    })
}
/**
 * 院校简介（编辑）
 * @param {*} query
 */
export const collegeIntroductPut = (query) => {
    return request({
        url: `${prefix}/recruitRegister/collegeIntroduct`,
        method: 'put',
       data: query
    })
}



/**
 * 复试名单（查询）
 * @param {*} query
 */
export const secondExamRosterList = (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster/list`,
         method: 'get',
        params: query
    })
}
/**
 * 复试名单（详情）
 * @param {*} query
 */
export const secondExamRosterDetail = (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster`,
         method: 'get',
        params: query
    })
}
/**
 * 复试名单（删除）
 * @param {*} query
 */
export const secondExamRosterDelete= (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster/list`,
         method: 'delete',
         data: query
    })
}

/**
 * 复试名单（创建）
 * @param {*} query
 */
export const secondExamRosterCreated= (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster`,
        method: 'post',
        data: query
    })
}
/**
 * 复试名单（编辑）
 * @param {*} query
 */
export const secondExamRosterPut= (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster`,
        method: 'put',
        data: query
    })
}
/**
 * 复试名单（导入）
 * @param {*} query
 */
export const secondExamRosterlmport= (query) => {
    return request({
        url: `${prefix}/recruitRegister/secondExamRoster/bulk/byFileImport`,
         method: 'post',
        data: query
    })
}


/**
 * 录取名单（查询）
 * @param {*} query
 */
export const recruitPrepareList = (query) => {
    return request({
        url: `${prefix}/recruitRegister/recruitPrepare/list`,
         method: 'get',
        params: query
    })
}
/**
 * 录取名单（创建）
 * @param {*} query
 */
export const recruitPrepareCreated= (query) => {
    return request({
        url: `${prefix}/recruitRegister/recruitPrepare`,
        method: 'post',
        data: query
    })
}
/**
 * 录取名单（详情）
 * @param {*} query
 */
export const recruitPrepareDetail = (query) => {
    return request({
         url: `${prefix}/recruitRegister/recruitPrepare`,
         method: 'get',
        params: query
    })
}
/**
 * 录取名单（编辑）
 * @param {*} query
 */
export const recruitPreparePut= (query) => {
    return request({
     url: `${prefix}/recruitRegister/recruitPrepare`,
        method: 'put',
        data: query
    })
}

/**
 * 录取名单（导入）
 * @param {*} query
 */
export const recruitPreparelmport= (query) => {
    return request({
        url: `${prefix}/recruitRegister/recruitPrepare/bulk/byFileImport`,
         method: 'post',
        data: query
    })
}
/**
 * 录取名单（删除）
 * @param {*} query
 */
export const recruitPrepareDelete= (query) => {
    return request({
        url: `${prefix}/recruitRegister/recruitPrepare/list`,
         method: 'delete',
         data: query
    })
}
/**
 * 录取分数线（查询）
 * @param {*} query
 */
export const scoreLine = (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine/list`,
         method: 'get',
        params: query
    })
}
/**
 * 录取分数线（创建）
 * @param {*} query
 */
export const scoreLineCreated= (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine`,
        method: 'post',
        data: query
    })
}
/**
 * 录取分数线（批量创建）
 * @param {*} query
 */
export const scoreLineBulkCreated= (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine/bulk`,
        method: 'post',
        data: query
    })
}
/**
 * 录取分数线（编辑）
 * @param {*} query
 */
export const scoreLinePut= (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine`,
        method: 'put',
        data: query
    })
}
/**
 * 录取分数线（删除）
 * @param {*} query
 */
export const scoreLineDelete= (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine/list`,
         method: 'delete',
         data: query
    })
}
/**
 * 录取分数线（查询详情）
 * @param {*} query
 */
export const scoreLineDetail = (query) => {
    return request({
         url: `${prefix}/recruitRegister/scoreLine`,
         method: 'get',
        params: query
    })
}

/**
 * 录取分数线（导入）
 * @param {*} query
 */
export const scoreLinelmport= (query) => {
    return request({
        url: `${prefix}/recruitRegister/scoreLine/bulk/byFileImport`,
         method: 'post',
        data: query
    })
}

/**
 * 参考书目（查询）
 * @param {*} query
 */
export const referenceBookList = (query) => {
    return request({
        url: `${prefix}/recruitRegister/referenceBook/list`,
         method: 'get',
        params: query
    })
}
/**
 * 参考书目（创建）
 * @param {*} query
 */
export const referenceBookCreated = (query) => {
    return request({
        url: `${prefix}/recruitRegister/referenceBook`,
         method: 'post',
        data: query
    })
} 
/**
 * 参考书目（查询详情）
 * @param {*} query
 */
export const referenceBookDetail = (query) => {
    return request({
         url: `${prefix}/recruitRegister/referenceBook`,
         method: 'get',
        params: query
    })
}
/**
 * 参考书目（编辑）
 * @param {*} query
 */
export const referenceBookPut= (query) => {
    return request({
     url: `${prefix}/recruitRegister/referenceBook`,
        method: 'put',
        data: query
    })
}
/**
 * 参考书目（删除）
 * @param {*} query
 */
export const referenceBookDelete= (query) => {
    return request({
        url: `${prefix}/recruitRegister/referenceBook/list`,
         method: 'delete',
         data: query
    })
}
/**
 * 参考书目（导入）
 * @param {*} query
 */
export const referenceBooklmport= (query) => {
    return request({
        url: `${prefix}/recruitRegister/referenceBook/bulk/byFileImport`,
         method: 'post',
        data: query
    })
}
/**
 * 调剂信息（导入）
 * @param {*} query
 */
export const adjustInfolmport= (query) => {
    return request({
        url: `${prefix}/recruitRegister/adjustInfo/bulk/byFileImport`,
         method: 'post',
        data: query
    })
}